export default {
  matSettings: {
    listing: {
      header: {
        feature: "Marketing Automation Tool Integration",
        heading: "Connect your Marketing Tools",
      },
      notFound: "No MAT Integrations found",
      oauthFailure: "OAuth failed, please try again",
      oauthForbidden:
        "Authorization was declined. Please authorize access by clicking 'Allow' to enable integration",
    },
    authentication: {
      header: {
        feature: "Authentication",
        heading: "{{integration}} Integration Authentication",
      },
    },
    configuration: {
      header: {
        feature: "Configuration",
        heading: "{{integration}} Integration Configuration",
      },
    },
  },
  shopSettings: {
    header: {
      feature: "Shop Settings",
      heading: "Control your shop settings and preferences",
    },
    tabs: {
      privacy: "Privacy Details",
      disableCheckout: "Disable checkout",
      emailInstallation: "Email Installation",
      preview: "Preview",
    },
    disableCheckout: {
      header: {
        heading: "Disable Shopify default consent collection",
        description:
          "If you need to disable Shopify default consent collection again, please see the instructions below.",
      },
      title: "Disable Shopify Consent Collection",
      instructions: {
        step1: "Navigate to your <1>Shopify Admin Checkout Settings</1>",
        step2:
          "Scroll down to <1>Marketing Options</1> and ensure that <3>Email Marketing</3> is <5>unchecked</5>",
        step3: "Click <1>Save</1>",
      },
    },
  },
};
